var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    baseProfile: "tiny",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000003"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.462 207.061c15.821 0 26.365 2.92 31.637 8.761 5.267 5.841 6.522 15.867 3.766 30.074-2.879 14.795-8.423 25.355-16.641 31.682-8.218 6.328-20.724 9.488-37.513 9.488h-25.33l15.549-80.005h28.532zM2 368.057h41.643l9.877-50.823h35.669c15.739 0 28.686-1.65 38.85-4.96 10.165-3.305 19.402-8.848 27.717-16.63 6.978-6.415 12.624-13.49 16.948-21.227 4.319-7.731 7.388-16.267 9.202-25.601 4.406-22.66 1.081-40.31-9.965-52.955s-28.619-18.967-52.709-18.967H39.154L2 368.057zM212.49 126.071h41.314l-9.878 50.823h36.806c23.157 0 39.132 4.042 47.924 12.117 8.791 8.08 11.425 21.17 7.91 39.266l-17.286 88.957h-41.97l16.436-84.582c1.87-9.622 1.184-16.185-2.064-19.684-3.248-3.5-10.159-5.251-20.729-5.251h-33.02L216.65 317.233h-41.315l37.155-191.162zM428.49 207.061c15.821 0 26.365 2.92 31.637 8.761 5.269 5.841 6.523 15.867 3.766 30.074-2.879 14.795-8.421 25.355-16.641 31.682-8.218 6.328-20.724 9.488-37.513 9.488H384.41l15.549-80.005h28.531zM327.029 368.057h41.643l9.876-50.823h35.669c15.739 0 28.686-1.65 38.851-4.96 10.164-3.305 19.401-8.848 27.717-16.63 6.979-6.415 12.624-13.49 16.948-21.227 4.318-7.731 7.388-16.267 9.201-25.601 4.406-22.66 1.082-40.31-9.965-52.955-11.046-12.645-28.619-18.967-52.709-18.967h-80.076l-37.155 191.163z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhp);
export default __webpack_public_path__ + "static/media/php.41dc175b656a22c526591a7c4ce8f97c.svg";
export { ForwardRef as ReactComponent };